module.exports = __webpack_public_path__ + "static/media/violinplay_adagioforreversestrings.951ae3d1.wav";